"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSubscriptionOutputDtoSchema = exports.updateSubscriptionInputDtoSchema = void 0;
const z = __importStar(require("zod"));
exports.updateSubscriptionInputDtoSchema = z.object({
    organizationId: z.string().min(1),
    contractId: z.string().min(1),
    packageAlias: z.string().min(1),
});
exports.updateSubscriptionOutputDtoSchema = z.discriminatedUnion('status', [
    z.object({
        status: z.literal('ok'),
    }),
    z.object({
        status: z.literal('no_payment_instrument'),
        stripeSetupIntentClientSecret: z.string().nullable(),
    }),
    z.object({
        status: z.literal('payment_required'),
        stripeInvoiceUrl: z.string(),
        purchaseRecordId: z.string(),
    }),
    z.object({
        status: z.literal('payment_pending'),
        purchaseRecordId: z.string(),
    }),
    z.object({
        status: z.literal('sales_managed'),
    }),
    z.object({
        status: z.literal('pending_change_exists'),
        effectiveAt: z.string(),
        targetAlias: z.string(),
        scheduledBy: z.enum(['customer', 'enforcement']),
    }),
]);
//# sourceMappingURL=update-subscription.dto.js.map